// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var FileLoader = require("./FileLoader");
var Expln_React_Row = require("@expln/utils/src/main/react-mui-components/Expln_React_Row.bs.js");
var MM_react_common = require("../ui-utils/MM_react_common.bs.js");
var Expln_React_Modal = require("@expln/utils/src/main/react-components/Expln_React_Modal.bs.js");
var Expln_React_Column = require("@expln/utils/src/main/react-mui-components/Expln_React_Column.bs.js");
var Expln_React_common = require("@expln/utils/src/main/Expln_React_common.bs.js");
var Paper = require("@mui/material/Paper").default;
var Expln_utils_promise = require("@expln/utils/src/main/Expln_utils_promise.bs.js");
var Button = require("@mui/material/Button").default;
var Checkbox = require("@mui/material/Checkbox").default;
var FormControlLabel = require("@mui/material/FormControlLabel").default;

function loadFile(url, onProgress, onReady, onError, param) {
  var prim1 = Belt_Option.getWithDefault(onProgress, (function (param, param$1) {
          
        }));
  var prim3 = Belt_Option.getWithDefault(onError, (function (param) {
          
        }));
  FileLoader.loadFile(url, prim1, onReady, prim3);
}

function loadFileWithProgress(modalRef, showWarning, onUrlBecomesTrusted, url, progressText, onReady, onError, transformErrorMsg, onTerminated, param) {
  var isTerminated = {
    contents: false
  };
  var makeActTerminate = function (modalId, param) {
    isTerminated.contents = true;
    if (onTerminated !== undefined) {
      Curry._1(onTerminated, undefined);
    }
    Expln_React_Modal.closeModal(modalRef, modalId);
  };
  var actDownloadFile = function (param) {
    Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                return MM_react_common.rndProgress(progressText, 0, undefined, undefined);
              })), (function (modalId) {
            Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                    return MM_react_common.rndProgress(progressText, 0, (function (param) {
                                  return makeActTerminate(modalId, param);
                                }), undefined);
                  }));
            loadFile(url, (function (loaded, total) {
                    var pct = loaded / total;
                    Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                            return MM_react_common.rndProgress(progressText, pct, (function (param) {
                                          return makeActTerminate(modalId, param);
                                        }), undefined);
                          }));
                  }), (function (text) {
                    if (!isTerminated.contents) {
                      Expln_React_Modal.closeModal(modalRef, modalId);
                      return Curry._1(onReady, text);
                    }
                    
                  }), (function (msg) {
                    Expln_React_Modal.closeModal(modalRef, modalId);
                    if (onError !== undefined) {
                      Curry._1(onError, msg);
                    }
                    if (transformErrorMsg !== undefined) {
                      Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                                  return null;
                                })), (function (modalId) {
                              Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                                      return React.createElement(Paper, {
                                                  style: {
                                                    padding: "10px"
                                                  },
                                                  children: Caml_option.some(React.createElement(Expln_React_Column.make, {
                                                            spacing: 1,
                                                            children: Caml_option.some(null)
                                                          }, Curry._1(transformErrorMsg, msg), React.createElement(Button, {
                                                                onClick: (function (param) {
                                                                    Expln_React_Modal.closeModal(modalRef, modalId);
                                                                  }),
                                                                variant: "contained",
                                                                children: "Ok"
                                                              })))
                                                });
                                    }));
                            }));
                      return ;
                    }
                    
                  }), undefined);
          }));
  };
  var dontAskAgain = {
    contents: false
  };
  if (showWarning) {
    Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                return null;
              })), (function (modalId) {
            Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                    return React.createElement(Paper, {
                                style: {
                                  padding: "10px"
                                },
                                children: Caml_option.some(React.createElement(Expln_React_Column.make, {
                                          spacing: 1,
                                          children: Caml_option.some(null)
                                        }, React.createElement("span", {
                                              style: {
                                                fontWeight: "bolder"
                                              }
                                            }, "Do you confirm downloading data from the below URL?"), React.createElement("span", undefined, url), React.createElement(FormControlLabel, {
                                              control: React.createElement(Checkbox, {
                                                    onChange: (function (param) {
                                                        return Expln_React_common.evt2bool((function (checked) {
                                                                      dontAskAgain.contents = checked;
                                                                    }), param);
                                                      })
                                                  }),
                                              label: "don't ask for this URL"
                                            }), React.createElement(Expln_React_Row.make, {
                                              children: Caml_option.some(null)
                                            }, React.createElement(Button, {
                                                  onClick: (function (param) {
                                                      if (dontAskAgain.contents) {
                                                        Curry._1(onUrlBecomesTrusted, url);
                                                      }
                                                      Expln_React_Modal.closeModal(modalRef, modalId);
                                                      actDownloadFile(undefined);
                                                    }),
                                                  variant: "contained",
                                                  children: "Confirm"
                                                }), React.createElement(Button, {
                                                  onClick: (function (param) {
                                                      Expln_React_Modal.closeModal(modalRef, modalId);
                                                    }),
                                                  variant: "outlined",
                                                  children: "Cancel"
                                                }))))
                              });
                  }));
          }));
    return ;
  } else {
    return actDownloadFile(undefined);
  }
}

exports.loadFile = loadFile;
exports.loadFileWithProgress = loadFileWithProgress;
/* react Not a pure module */
